<h2 class="cbms-h2">SMART Alert Templates</h2>
<div class="table-wrapper">
    <p-table
        [value]="alertTemplateList"
        [lazy]="true"
        [columns]="cols"
        [rows]="pageInfo.pageSize"
        [first]="firstIndex"
        (onLazyLoad)="loadTemplateListLazily($event)"
        [totalRecords]="pageInfo.totalElements"
        [loading]="isLoading"
        [paginator]="true"
        responsiveLayout="scroll"
        [scrollable]="true"
        scrollHeight="flex"
        [rowHover]="true"
        dataKey="id"
        class="cbms-generic-table-style"
    >
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-end">
                <div>
                    <button pButton class="p-button-raised p-button-text cbms-button cbms-button__turquoise-bg"
                            (click)="addTemplate()"
                            [disabled]="false">
                        Add Template
                    </button>
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header" let-columns>
            <tr>
                <th style="flex: 0 0 3rem !important; min-width: 3rem">
                    <div class="cbms-disply-flex-row-centered">
                        <span>Actions</span>
                    </div>
                </th>

                <th *ngFor="let col of columns"
                    [pSortableColumn]="col.field"
                    pResizableColumn
                    [style.flex-basis]="col.width"
                    [style.min-width]="col.width">
                    <div class="cbms-disply-flex-row-centered">
                        <span>{{ col.header }}</span>
                        <p-sortIcon
                            [field]="col.field"
                            ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"
                        ></p-sortIcon>
                    </div>
                </th>
                <th style="flex: 0 0 3rem !important; min-width: 3rem">
                    <div class="cbms-disply-flex-row-centered">
                        <span>PROGRESS</span>
                    </div>
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-template let-columns="columns">
            <tr>
                <td style="flex: 0 0 3rem !important; min-width: 3rem">
                    <button
                        pButton
                        class="p-button-raised p-button-text cbms-row-button"
                        pTooltip="Delete alert template"
                        showDelay="1000"
                        hideDelay="500"
                        (click)="deleteMenu.show($event)"
                        [disabled]="getAlertTemplateStatus(template.id)?.status === 'IN_PROGRESS'"
                    >
                        <mat-icon svgIcon="delete"></mat-icon>
                    </button>

                    <button
                        pButton
                        type="button"
                        icon="pi pi-pencil"
                        class="ui-button-info cbms-margin-left"
                        (click)="editTemplate(template)"
                        [disabled]="getAlertTemplateStatus(template.id)?.status === 'IN_PROGRESS'"
                    ></button>

                    <p-overlayPanel #deleteMenu appendTo="body">
                        <p>
                            Please confirm you want to continue with the removal of this SMART Alert Template. Deleting
                            this will also delete the rules generated for the selected Sites.
                        </p>
                        <hr>
                        <div class="delete-action-buttons">
                            <button pButton class="p-button-raised p-button-text cbms-button cbms-button__turquoise-bg"
                                    label="Confirm"
                                    (click)="deleteSmartAlertTemplate(template); deleteMenu.hide();"></button>
                            <button pButton class="p-button-raised p-button-text cbms-button"
                                    (click)="deleteMenu.hide()">Cancel
                            </button>
                        </div>
                    </p-overlayPanel>
                </td>
                <td
                    *ngFor="let col of columns"
                    [style.flex-basis]="col.width"
                    [style.min-width]="col.width"
                >

                    <ng-container [ngSwitch]="col.field">
                        <ng-container *ngSwitchCase="'isEnabled'">
                            <p-inputSwitch [disabled]="true"
                                           [(ngModel)]="template[col.field]"
                                           *ngIf="getAlertTemplateStatus(template.id)?.status === 'IN_PROGRESS'"
                            ></p-inputSwitch>
                            <ng-container *ngIf="getAlertTemplateStatus(template.id)?.status !== 'IN_PROGRESS'">
                            <p-inputSwitch #inputSwitch [(ngModel)]="template[col.field]"
                                           (click)="$event.stopPropagation(); inputSwitch.setDisabledState(true); templateEnabledMenu.show($event)"
                            ></p-inputSwitch>
                            <p-overlayPanel #templateEnabledMenu appendTo="body" dismissable="false" baseZIndex="1000">
                                <p>
                                    <ng-container [ngSwitch]="template[col.field]">
                                        <span *ngSwitchCase="true">
                                            @if (template?.sitesCount > 0) {
                                                Please confirm you want to activate this template. This will also activates
                                                the corresponding rule(s).
                                            } @else {
                                                Please select at least one Site to activate this template.
                                            }
                                        </span>
                                        <span *ngSwitchCase="false">
                                            Please confirm you want to deactivate this template. This will also deactivate
                                            the corresponding rule(s).
                                        </span>
                                    </ng-container>
                                </p>
                                <hr>
                                <div class="delete-action-buttons">
                                    <button pButton
                                            *ngIf="template?.sitesCount > 0"
                                            class="p-button-raised p-button-text cbms-button cbms-button__turquoise-bg"
                                            label="Confirm"
                                            (click)="changeAlertTemplateStatus(template); inputSwitch.setDisabledState(false);templateEnabledMenu.hide();"></button>
                                    <button pButton class="p-button-raised p-button-text cbms-button"
                                            (click)="template[col.field] = !template[col.field]; inputSwitch.setDisabledState(false);templateEnabledMenu.hide()">
                                        Cancel
                                    </button>
                                </div>
                            </p-overlayPanel>
                            </ng-container>

                        </ng-container>

                        <ng-container *ngSwitchDefault>{{ template[col.field] }}</ng-container>
                    </ng-container>
                </td>
                <td>
                    <!-- inprogress column -->
                    <div class="flex flex-row align-items-center ">
                        <ng-container [ngSwitch]="getAlertTemplateStatus(template.id)?.status">
                            <ng-container *ngSwitchCase="'IN_PROGRESS'" >
                                <strong class="cbms-red-color">In Progress... {{ getAlertTemplateStatus(template.id)?.progressPercentage.toFixed(2) }}%</strong>
                                <mat-spinner [diameter]="30" class="cbms-spinner m-0 ml-3"></mat-spinner>
                            </ng-container>
                            <ng-container *ngSwitchCase="'FAILED'">
                                <span class="cbms-text-red">Failed</span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'COMPLETED'">
                                <span>Completed</span>
                            </ng-container>
                            <ng-container *ngSwitchDefault>&nbsp;</ng-container>
                        </ng-container>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
